import React, { useEffect } from "react";

const GoogleSearch = () => {
  useEffect(() => {
    const cx = "264be1db82ce84ca3";

    // Удалим предыдущий скрипт, если он был
    const existingScript = document.querySelector(`script[src*="cse.google.com/cse.js?cx=${cx}"]`);
    if (existingScript) {
      // NotFoundError: The object can not be found here.
      // existingScript.remove();
    }

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `https://cse.google.com/cse.js?cx=${cx}`;

    document.body.appendChild(script);
  }, []);

  return (
    <>
      {/*<script*/}
      {/*  async*/}
      {/*  src="https://cse.google.com/cse.js?cx=264be1db82ce84ca3"*/}
      {/*>*/}
      {/*</script>*/}

      {/* Call to Action */}
      {/*<section className="text-center max-w-5xl mx-auto space-y-4 pt-12 text-gray-800">*/}
      {/*  <div className="pt-12">*/}
      {/*    /!*<p className="text-gray-500 italic mb-8 text-xl">Search routes in</p>*!/*/}
      {/*    <div className="gcse-search"></div>*/}
      {/*  </div>*/}
      {/*</section>*/}

      {/* Call to Action */}
      <section className="max-w-5xl mx-auto pt-12 pb-12  space-y-12 px-4 text-gray-800">
        <h2 className="text-3xl font-semibold text-center">Search in routes created by community</h2>
        <div>
          <div className="gcse-search"></div>
        </div>
      </section>
    </>
  );
}

export default GoogleSearch;